import React from 'react';
import { CircularProgress } from '.'


export const LoadComponent = ({ isLoading = false, children }) => {

    return (
        <>
            {children}
            {/* {isLoading ? (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1}}>
                        <CircularProgress color='primary' />
                    </div>
                ) : (
                    children
                )
            } */}
        </>
    );
}